export default "__VITE_ASSET__BQmr7rIs__"